var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19178",
    "data-name": "Group 19178",
    transform: "translate(-230 -1210.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19177",
    "data-name": "Group 19177"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(230 1210.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18245",
    "data-name": "Group 18245",
    transform: "translate(-6.688 -0.838)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1462",
    "data-name": "Line 1462",
    x2: 2.302,
    y2: 2.302,
    transform: "translate(238.537 1213.514)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1463",
    "data-name": "Line 1463",
    x1: 2.302,
    y2: 2.302,
    transform: "translate(238.537 1213.514)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switchOff.591da6757b67edbc2fb23c1cb8c549df.svg";
export { ForwardRef as ReactComponent };